import { render, staticRenderFns } from "./TokenAmount.vue?vue&type=template&id=40fa5e65&scoped=true&"
import script from "./TokenAmount.vue?vue&type=script&lang=js&"
export * from "./TokenAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa5e65",
  null
  
)

export default component.exports